import { Field } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function PasswordField({
  name,
  placeholder = "",
  autoComplete = "current-password",
}) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <div className="position-relative">
      <Field
        type={visible ? "text" : "password"}
        name={name}
        autoComplete={autoComplete}
        className="common-input common-input--withIcon"
        placeholder={placeholder}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={
          visible
            ? t("authModal.password.hide")
            : t("authModal.password.show")
        }
        aria-pressed={visible}
        className="input-icon bg-transparent border-0 p-0 d-inline-flex align-items-center justify-content-center"
        style={{ cursor: "pointer", lineHeight: 1 }}
      >
        <i
          className={visible ? "las la-eye-slash" : "las la-eye"}
          style={{ fontSize: "1.25rem" }}
        />
      </button>
    </div>
  );
}

export default PasswordField;
